import {Part} from "../part";
import {windowThumbnail} from '../../../bvComponent/core/assets';
import {PartMenuType} from "../../../visComponents/constants";
import WindowKits from "../subparts/window/windowKits";
import WindowBody from "../subparts/window/windowBody";

export class WindowParent extends Part {
  static id = 'Window';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Window';
    this.homePageTitle = 'Windows';
    this.translateId = "visualizer.bathroom.window";
    this.partThumbnail = windowThumbnail;
    this.windowBody = null;
    this.relatedGroupNames = ["Window Kit", "Window"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Window Kit":
      case "Window Kits": {
        relatedItemName = "windowKits";
        RelatedItemClass = WindowKits;
        break;
      }
      case "Window": {
        relatedItemName = "windowBody";
        RelatedItemClass = WindowBody;
        break;
      }
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
  }
}
